import { useLazyQuery } from '@apollo/client';
import React, { useEffect } from 'react'
import { GetMomNameByNodeId } from '../../masters/projects/queries/queries';
import { AtsMomMaster, GetMomNodeResult, GetMomNodeVars } from '../queries/types';
import { nodeVar } from '../../../../../utils/commonQueryTypes';
import { toStandardDate } from '../../../../../utils/UtilFunctions';
import { GetMomNode } from '../queries/query';
import useUrlParams from '../../../../../customHooks/useUrlParams';
interface Props
{
    fill: boolean;
    momId: number;
    latest: boolean;

}
const MeetingHeader = ( { fill, momId, latest }: Props ) =>
{

    const { customer_id } = useUrlParams();
    const [ GetMomDate, { data } ] = useLazyQuery<
        GetMomNodeResult,
        GetMomNodeVars
    >( GetMomNode );

    useEffect( () =>
    {
        if ( momId )
        {
            GetMomDate( {
                variables: {
                    customerID: customer_id!,
                    momID: momId,
                    latest,
                }
            } );
        }

    }, [ data, momId, GetMomDate, customer_id, latest ] )

    if ( data )
        return (
            <>
                <div>
                    Meeting No : {" "}
                    <span>
                        {data.GetMomNode.meetingNo}
                    </span>
                </div>
                {fill
                    ? "Fill Details for Meeting :"
                    : "Meeting Details :"}
                {toStandardDate( data.GetMomNode.meetingDate )
                }
            </>
        )

    else
        return <></>
}

export default MeetingHeader